import { render, staticRenderFns } from "./BarEdpByBrancheChart.vue?vue&type=template&id=45be660d&"
import script from "./BarEdpByBrancheChart.vue?vue&type=script&lang=ts&"
export * from "./BarEdpByBrancheChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports